export const DISEASE_STATUSES = {
    IN_EXACERBATION: 'In exacerbation',
    ACTIVELY_MONITORING: 'Actively monitoring',
    WORSENING: 'Worsening',
    CHRONIC_MANAGED: 'Chronic, managed',
    ACTIVE: 'Active',
    RESOLVED: 'Resolved',
};
